var _style, _g, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnrampprocessing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ecqKrGdbN7J1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 76 32",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "#ecqKrGdbN7J2_to {animation: ecqKrGdbN7J2_to__to 1500ms linear infinite normal forwards}@keyframes ecqKrGdbN7J2_to__to { 0% {transform: translate(-0.5px,16px)} 100% {transform: translate(76px,16px)}}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ecqKrGdbN7J2_to",
    transform: "translate(-0.5,16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.5,11c-.9889,0-1.9556.2932-2.7779.8427-.8222.5494-1.4631,1.3303-1.8415,2.2439s-.4775,1.9189-.2845,2.8889.6691,1.8608,1.3684,2.56c.6992.6993,1.5901,1.1755,2.56,1.3684s1.9753.0939,2.8889-.2845s1.6945-1.0193,2.2439-1.8415c.5495-.8223.8427-1.789.8427-2.7779c0-1.3261-.5268-2.5979-1.4645-3.5355C39.0979,11.5268,37.8261,11,36.5,11Zm0,8c-.5933,0-1.1734-.1759-1.6667-.5056-.4934-.3296-.8779-.7982-1.1049-1.3463-.2271-.5482-.2865-1.1514-.1708-1.7334.1158-.5819.4015-1.1165.8211-1.536.4195-.4196.9541-.7053,1.536-.8211s1.1852-.0563,1.7334.1708c.5481.227,1.0167.6115,1.3463,1.1049.3297.4933.5056,1.0734.5056,1.6667c0,.7956-.3161,1.5587-.8787,2.1213s-1.3257.8787-2.1213.8787Zm14-12h-28c-.2652,0-.5196.10536-.7071.29289s-.2929.44189-.2929.70711v16c0,.2652.1054.5196.2929.7071s.4419.2929.7071.2929h28c.2652,0,.5196-.1054.7071-.2929s.2929-.4419.2929-.7071v-16c0-.26522-.1054-.51957-.2929-.70711s-.4419-.29289-.7071-.29289ZM44.7062,23h-16.4125c-.3357-1.1355-.9502-2.1689-1.7875-3.0062s-1.8707-1.4518-3.0062-1.7876v-4.4125c1.1355-.3357,2.1689-.9502,3.0062-1.7875s1.4518-1.8707,1.7875-3.0062h16.4125c.3358,1.1355.9503,2.1689,1.7876,3.0062s1.8707,1.4518,3.0062,1.7875v4.4125c-1.1355.3358-2.1689.9503-3.0062,1.7876s-1.4518,1.8707-1.7876,3.0062ZM49.5,11.6713C48.3005,11.1555,47.3445,10.1995,46.8288,9L49.5,9v2.6713ZM26.1712,9c-.5157,1.1995-1.4717,2.1555-2.6712,2.6713L23.5,9h2.6712ZM23.5,20.3288c1.1995.5157,2.1555,1.4717,2.6712,2.6712L23.5,23v-2.6712ZM46.8288,23c.5157-1.1995,1.4717-2.1555,2.6712-2.6712v2.6712h-2.6712Z",
    transform: "translate(-36.5,-16)",
    fill: "#108934"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5,13h12",
    fill: "none",
    stroke: "#e89910",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5,21h12",
    fill: "none",
    stroke: "#e89910",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5,14h6",
    fill: "none",
    stroke: "#e89910",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5,20h6",
    fill: "none",
    stroke: "#e89910",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnrampprocessing);
export default __webpack_public_path__ + "static/media/onrampprocessing.95961ed56be1a4687e1829cca0c67c47.svg";
export { ForwardRef as ReactComponent };